import Datalayer from './data/Datalayer'
import AnalyticsProvider from './provider/AnalyticsProvider'
import Status from './status/Status'

interface IAnalyticsProvider {
  new (...args: any[]): AnalyticsProvider
}

const userActions = ['mousemove', 'scroll', 'keydown', 'click', 'touchstart']

export default class Analytics {
  providers: AnalyticsProvider[] = []

  eventsQueue = []
  isInitialized = false

  executeProvidersInitialize = (): void => {
    for (const action of userActions) {
      window.removeEventListener(action, this.executeProvidersInitialize)
    }

    for (const provider of this.providers) {
      provider.init()
    }

    this.isInitialized = true

    if (this.eventsQueue.length) {
      this.eventsQueue.forEach(({data, providers}) => {
        this.sendEvent(data, providers)
      })

      this.eventsQueue = []
    }

    window.dispatchEvent(new CustomEvent('initializedAnalyticsProviders'))
  }

  async initialize(providers: AnalyticsProvider[]): Promise<AnalyticsProvider[]> {
    return new Promise<AnalyticsProvider[]>(resolve => {
      for (const provider of providers) {
        this.providers.push(provider)
      }

      window.addEventListener('initializedAnalyticsProviders', () => {
        resolve(this.providers)
      })

      for (const action of userActions) {
        window.addEventListener(action, this.executeProvidersInitialize)
      }
    })
  }

  async sendEvent(data: Datalayer, providers?: IAnalyticsProvider[]): Promise<Status[]> {
    if (!this.isInitialized) {
      this.eventsQueue.push({data, providers})
      return
    }

    const collection = []

    for (const provider of this.providers) {
      if (!providers) {
        if (provider.isActive) {
          collection.push(provider.sendEvent(data))
        }
      } else {
        for (const pr of providers) {
          if (pr.name === provider.constructor.name) {
            collection.push(provider.sendEvent(data))
          }
        }
      }
    }

    return Promise.all(collection)
  }
}
